import { getLevelCommercialArea as r } from "../level-metrics/index10.js";
import { getLevelArrayMetric as t } from "../index4.js";
const a = (e) => t(e, r);
export {
  a as getLevelArrayCommercialArea
};
//# sourceMappingURL=index4.js.map
